import axios from '../config/axios'

const API_BASE = '/amount-adjustments'

const amountAdjustmentService = {
  list: (params = {}) => axios.get(API_BASE, { params }),
  create: (data) => axios.post(API_BASE, data),
  approve: (requestId, data) => axios.post(`${API_BASE}/${encodeURIComponent(requestId)}/approve`, data),
  reject: (requestId, data) => axios.post(`${API_BASE}/${encodeURIComponent(requestId)}/reject`, data),
}

export default amountAdjustmentService
